{
  "version": 1,
  "asset_id": "23c0e792-17e1-4673-8777-96272a2cb791",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/23c0e792-17e1-4673-8777-96272a2cb791/gastric-bypass-v2-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/23c0e792-17e1-4673-8777-96272a2cb791/gastric-bypass-v2-800.jpg",
  "original_filename": "gastric-bypass-v2-800.jpg",
  "size": 61542,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:01:02Z"
}
